import React from 'react';
import { withIcon } from '../../../../components/withIcon/withIcon.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SvgVocalign = (_a) => {
  var _b = _a, { size, title = "Vocalign" } = _b, props = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36",
    width: size,
    height: size,
    "data-icon-name": title,
    "aria-label": title,
    role: "presentation"
  }, props), /* @__PURE__ */ React.createElement("path", {
    fill: "#435261",
    d: "M3.315 34.065l-1.38-1.38a.75.75 0 01-.094-.947L4.5 27.75l3.75 3.75-3.988 2.659a.75.75 0 01-.947-.094z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#142739",
    d: "M8.727 32.266a.748.748 0 01-.53-.22l-4.243-4.243a.75.75 0 01-.065-.986L15.75 12.75l7.5 7.5L9.182 32.112a.75.75 0 01-.455.154z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#E11534",
    d: "M10.5 23.25a.75.75 0 01-.53-1.28l2.25-2.25a.75.75 0 111.06 1.06l-2.25 2.25a.748.748 0 01-.53.22z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#435261",
    d: "M17.856 18.144c3.801 3.802 9.987 3.802 13.788 0L17.856 4.356c-3.802 3.801-3.802 9.987 0 13.788z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#435261",
    d: "M31.644 4.356c-3.801-3.802-9.987-3.802-13.788 0l13.788 13.788c3.802-3.801 3.802-9.987 0-13.788z"
  }), /* @__PURE__ */ React.createElement("path", {
    fill: "#142739",
    d: "M31.5 18.75a.748.748 0 01-.53-.22l-13.5-13.5a.75.75 0 111.06-1.06l13.5 13.5a.75.75 0 01-.53 1.28z"
  }));
};
var Vocalign = withIcon(SvgVocalign);

export { Vocalign as default };
//# sourceMappingURL=Vocalign.es.js.map
